import { render } from "./productBoxSlider.vue?vue&type=template&id=2d959726&ts=true"
import script from "./productBoxSlider.vue?vue&type=script&lang=ts"
export * from "./productBoxSlider.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__